import React from 'react';
import { SheetContent } from '@/components/ui/sheet';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/shared/Input/Input';
import { X } from 'lucide-react';
import useModalStore from '@/store/useModalStore';
import { useTranslation } from 'react-i18next';

export default function AdvanceForm() {
  const { t } = useTranslation('wallet');
  const { closeModal } = useModalStore();
  const [value, setValue] = React.useState('0,00');

  return (
    <SheetContent className="flex flex-col h-full w-[480px] max-w-[95%]">
      <div className="flex items-center justify-between p-6 border-b border-zinc-800">
        <h2 className="text-xl font-bold">{t("requestAdvance")}</h2>
        <button onClick={() => closeModal('advance-form')}>
          <X size={20} className="text-zinc-500 hover:text-white" />
        </button>
      </div>

      <div className="p-6 space-y-6">
        <div>
          <p className="text-sm mb-2">{t("advanceValueDescription")}</p>
          <Input
            type="text"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            prefix="R$"
            className="h-9"
          />
          <p className="text-sm text-zinc-400 mt-1">{t("maxValue")}: R$ 250,00</p>
        </div>

        <div className="bg-zinc-800/50 p-4 rounded-lg">
          <p className="text-sm text-zinc-400">
            {t("advanceRequestDisclaimer")}
          </p>
        </div>
      </div>

      <div className="mt-auto p-6 border-t border-zinc-800 flex justify-end gap-2">
        <Button variant="ghost" onClick={() => closeModal('advance-form')}>
          {t("cancel")}
        </Button>
        <Button className="bg-[#27272A] text-white hover:bg-[#27272A] ">
          {t("confirmAdvance")}
        </Button>
      </div>
    </SheetContent>
  );
}